import { Navigate, Outlet } from "react-router-dom";

function readPerms() {
  try {
    return JSON.parse(localStorage.getItem("tienda_permisos") || "[]");
  } catch {
    return [];
  }
}

export default function RequirePerm({
  perm,
  anyOf,
  redirectTo = "/administracion/tienda",
}) {
  const perms = readPerms();
  // `anyOf` (arreglo): basta con tener cualquiera de esos permisos.
  // Si no se pasa, se usa el modo clásico de un solo `perm`.
  const required = Array.isArray(anyOf) && anyOf.length ? anyOf : [perm];
  const ok = required.some((p) => perms.includes(p));

  if (!ok) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}